const api_host = 'https://admin-prod.csionet.com:8443'
// const api_host = 'http://localhost:8888'
// https://admin-dev.csionet.com:8443
//https://admin-qa.csionet.com:8443
//https://admin-dev.csionet.com:8443
export default api_host
